import router from 'controllers/vue_components/router'

// Page components are lazy, so the first click on a link waits for its chunk. Starting
// that download when the pointer lands on the link (or a finger touches it) hides most
// of the wait. Resolved chunks replace the loader function on the route record, so
// repeat calls are free, and the Set stops repeated hovers from re-resolving a path.
const seen = new Set()

// The same test vue-router uses to tell a lazy loader from a component.
function isLazyLoader(component) {
  return typeof component === 'function' &&
    !('displayName' in component) && !('props' in component) && !('__vccOpts' in component)
}

export function prefetchRoute(href) {
  if (!href || seen.has(href)) return
  seen.add(href)
  try {
    router.resolve(href).matched.forEach((record) => {
      Object.values(record.components || {}).forEach((component) => {
        if (isLazyLoader(component)) component().catch(() => seen.delete(href))
      })
    })
  } catch {
    seen.delete(href)
  }
}
